import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  // Alert as MuiAlert,
  Box,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  Button as MuiButton,
  // TextField as MuiTextField,
  Divider,
  Typography,
  IconButton,
  Tooltip,
  TextField,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import axios from "axios";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { DataGrid, GridToolbar, GridFooter } from "@mui/x-data-grid";
// import moment from "moment";
import ViewCustomerInvoiceDialog from "../components/ViewCustomerInvoiceDialog";
import ConfirmDialog from "../components/ConfirmDialog";
import Notification from "../components/Notification";
import apiUtils from "../utils/apiUtils";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { format, isValid, parseISO } from "date-fns";
import { nl } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import { useDataGridLocaleText } from "../utils/useDataGridLocaleText";
// import List from "@mui/material/List";

const Card = styled(MuiCard)(spacing);
// const Alert = styled(MuiAlert)(spacing);
// const TextField = styled(MuiTextField)(spacing);
const Button = styled(MuiButton)(spacing);

const toDateInputValue = (value) => {
  if (value == null || value === "") return "";
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return "";
  return d.toISOString().slice(0, 10);
};

export default function ViewClaimDialog(props) {
  const { t } = useTranslation();
  const dataGridLocaleText = useDataGridLocaleText();
  const supplierData = apiUtils.useApiData("/api/v1/suppliers");
  const currencyData = apiUtils.useApiData("/api/v1/currencies");
  const productData = apiUtils.useApiData("/api/v1/productTypes");
  // const invoiceLabelData = apiUtils.useApiData("/api/v1/invoiceLabels");
  // const invoiceStateData = apiUtils.useApiData("/api/v1/invoiceStates");
  const countryData = apiUtils.useApiData("/api/v1/countries");
  // const paymentTypeData = apiUtils.useApiData("/api/v1/paymentTypes");
  // const claimStateData = apiUtils.useApiData("/api/v1/claimStates");

  const { viewClaimDialog, setViewClaimDialog, refreshTable } = props;
  const customerId = viewClaimDialog?.custInfo[0]?.customerId;
  const customerNumber = viewClaimDialog?.custInfo[0]?.customerNumber;
  const [bankAccounts, setBankAccounts] = useState([]);

  useEffect(() => {
    if (!customerId) return;

    const fetchBankAccounts = async () => {
      try {
        const response = await axios.get("/api/v1/bankaccountsByEntityId/" + customerId);
        setBankAccounts(response.data);
      } catch (error) {
        console.error("Failed to fetch bank accounts", error);
      }
    };

    fetchBankAccounts();
  }, [customerId]);

  // console.log(viewClaimDialog);
  // alert(customerId);
  const [payableToDelta, setPayableToDelta] = useState(false); // You can set this to a predefined value if needed
  const [invoiceGridData, setInvoiceGridData] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [updatingClaim, setUpdatingClaim] = useState(false);
  const [pageSize, setPageSize] = React.useState(15);
  const [dataVersion] = useState(0);
  const selectedClaimId = useRef();

  // const [selectedPaymentTypeId, setSelectedPaymentTypeId] = useState("");
  const [selectedClaimStateId, setSelectedClaimStateId] = useState("");
  // const [selectedLiters, setSelectedLiters] = useState("");
  // const [selectedAdvancedRefundAmountEUR, setSelectedAdvancedRefundAmountEUR] =
  // useState("");
  const [selectedClaimDate, setSelectedClaimDate] = useState("");
  // const [selectedNotificationDate, setSelectedNotificationDate] = useState("");
  const [selectedReimbursementDate, setSelectedReimbursementDate] = useState("");
  // const [selectedPaymentDate, setSelectedPaymentDate] = useState("");
  const [selectedBankAccount, setSelectedBankAccount] = useState(() => {
    return viewClaimDialog?.params?.payableBankAccountId;
  });
  // const [selectedBankAccountDelta, setSelectedBankAccountDelta] = useState("");
  const [selectedClaimPreview, setSelectedClaimPreview] = useState([]);

  const [invoiceCount, setInvoiceCount] = useState(0);
  const [totalGrossAmount, setTotalGrossAmount] = useState(0);
  const [totalVATAmount, setTotalVATAmount] = useState(0);
  const [missingInvoiceCopies, setMissingInvoiceCopies] = useState(0);
  const [gridTotalGrossAmount, setGridTotalGrossAmount] = useState(0);
  const [gridTotalVATAmount, setGridTotalVATAmount] = useState(0);

  const [notify, setNotify] = useState({ isOpen: false, message: "", type: "success" });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
    onConfirm: () => {},
  });
  const [paymentReceivedDateInput, setPaymentReceivedDateInput] = useState("");
  const [paymentAmountInput, setPaymentAmountInput] = useState("");
  const [savingPayment, setSavingPayment] = useState(false);
  const [removingPayment, setRemovingPayment] = useState(false);
  const isPaymentBusy = savingPayment || removingPayment;

  const paymentReceivedDateValue = React.useMemo(() => {
    if (!paymentReceivedDateInput) return null;
    const parsed = parseISO(paymentReceivedDateInput);
    return isValid(parsed) ? parsed : null;
  }, [paymentReceivedDateInput]);

  // const [bankAccountsFiltered, setBankAccountsFiltered] = useState([]);
  // const [bankAccountsDelta, setBankAccountsDelta] = useState([]);

  // const [showPopup, setShowPopup] = useState(false);
  // const [openConfirmation, setOpenConfirmation] = useState(false);
  // const [responseMessage, setResponseMessage] = useState("");
  // const overlayStyle = {
  //   position: "fixed",
  //   top: 0,
  //   left: 0,
  //   width: "100%",
  //   height: "100%",
  //   backgroundColor: "rgba(0, 0, 0, 0.5)",
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   zIndex: 9999,
  // };

  // const popupStyle = {
  //   backgroundColor: "white",
  //   padding: "20px",
  //   borderRadius: "5px",
  //   boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
  //   textAlign: "center",
  // };

  // const [gridTotalVATAmountEur, setGridTotalVATAmountEur] = useState(0);

  // const [alertInfo, setAlertInfo] = useState({ message: "", type: "" });

  const gridRef = React.useRef();

  // const invoiceGridDataJson = JSON.stringify(invoiceGridData);

  // console.table(viewClaimDialog.params);

  const getPreviewData = useCallback(async () => {
    setLoading(true);
    if (!customerId || !selectedClaimId.current) {
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(
        "/api/v1/claims/claimView/" + customerId + "/" + selectedClaimId.current
      );
      setSelectedClaimPreview(response.data);
      const filteredInvoices = response.data.customerInvoices.filter(
        (invoice) =>
          ((invoice.invoiceStateId === 1 || invoice.invoiceStateId === 3 || invoice.invoiceStateId === 9) &&
            invoice.claimId === response.data.claimId) ||
          ((invoice.invoiceStateId === 2 || invoice.invoiceStateId === 3 || invoice.invoiceStateId === 4) &&
            (invoice.claimId === null || invoice.claimId === 0) &&
            response.data.claimStateId === 1)
      );
      setPayableToDelta(response.data.claimCode.slice(-1) === "1");

      setSelectedBankAccount(response.data.payableBankAccountId);
      setInvoiceGridData(filteredInvoices);

      setPaymentReceivedDateInput(toDateInputValue(response.data.paymentReceivedDate));
      const amt = response.data.paymentAmount;
      if (amt != null && amt !== "") {
        setPaymentAmountInput(String(amt));
      } else {
        setPaymentAmountInput("");
      }
    } catch (error) {
      console.error("Failed to load claim view", error);
    } finally {
      setLoading(false);
    }
  }, [customerId]);

  const calculateTotals = useCallback(() => {
    // console.log("calculateTotals");
    if (invoiceGridData.length === 0) {
      return;
    }
    let invoiceCount = 0;
    let totalGrossAmount = 0;
    let totalVATAmount = 0;
    let missingInvoiceCopies = 0;
    let gridTotalGrossAmount = 0;
    let gridTotalVATAmount = 0;
    invoiceGridData.forEach((row) => {
      gridTotalGrossAmount += row.invoiceGrossAmount;
      gridTotalVATAmount += row.invoiceVATAmountLocalCurrency;
      if (row.invoiceStateId === 3) {
        invoiceCount++;
        totalGrossAmount += row.invoiceGrossAmount;
        totalVATAmount += row.invoiceVATAmountLocalCurrency;
      }
    });
    setInvoiceCount(invoiceCount);
    setTotalGrossAmount(totalGrossAmount);
    setTotalVATAmount(totalVATAmount);
    setMissingInvoiceCopies(missingInvoiceCopies);
    setGridTotalGrossAmount(gridTotalGrossAmount);
    setGridTotalVATAmount(gridTotalVATAmount);
  }, [invoiceGridData]);

  const showNotify = (type, message) => {
    setNotify({ isOpen: true, message, type });
  };

  const persistClaimPayment = async (paymentReceivedDate, paymentAmount) => {
    setSavingPayment(true);
    try {
      await axios.put(`/api/v1/claims/${selectedClaimId.current}/payment`, {
        paymentReceivedDate,
        paymentAmount,
      });
      showNotify("success", t("Payment information saved successfully."));
      setConfirmDialog((prev) => ({ ...prev, isOpen: false }));
      await getPreviewData();
      if (typeof refreshTable === "function") {
        refreshTable();
      }
    } catch (error) {
      const status = error.response?.status;
      if (status === 404) {
        showNotify("error", t("Claim not found"));
      } else {
        showNotify("error", t("Error saving payment information"));
      }
      setConfirmDialog((prev) => ({ ...prev, isOpen: false }));
    } finally {
      setSavingPayment(false);
    }
  };

  const removeClaimPayment = async () => {
    setRemovingPayment(true);
    try {
      await axios.put(`/api/v1/claims/${selectedClaimId.current}/payment`, {
        paymentReceivedDate: null,
        paymentAmount: null,
      });
      showNotify("success", t("Payment information removed successfully."));
      setConfirmDialog((prev) => ({ ...prev, isOpen: false }));
      await getPreviewData();
      if (typeof refreshTable === "function") {
        refreshTable();
      }
    } catch (error) {
      const status = error.response?.status;
      if (status === 404) {
        showNotify("error", t("Claim not found"));
      } else {
        showNotify("error", t("Error removing payment information"));
      }
      setConfirmDialog((prev) => ({ ...prev, isOpen: false }));
    } finally {
      setRemovingPayment(false);
    }
  };

  const handleSavePaymentClick = () => {
    if (!paymentReceivedDateInput) {
      showNotify("error", t("Payment date is required"));
      return;
    }
    const sanitized = String(paymentAmountInput).replace(",", ".");
    const amountFloat = parseFloat(sanitized);
    if (String(paymentAmountInput).trim() === "" || Number.isNaN(amountFloat) || amountFloat <= 0.01) {
      showNotify("error", t("Payment amount should be a decimal and higher than 0.01"));
      return;
    }
    setConfirmDialog({
      isOpen: true,
      title: t("Confirm payment information"),
      subTitle: t("Are you sure you want to save the payment date and amount for this claim?"),
      onConfirm: () => {
        void persistClaimPayment(paymentReceivedDateInput, amountFloat);
      },
    });
  };

  const handleRemovePaymentClick = () => {
    setConfirmDialog({
      isOpen: true,
      title: t("Confirm remove payment information"),
      subTitle: t("Are you sure you want to remove the payment date and amount for this claim?"),
      onConfirm: () => {
        void removeClaimPayment();
      },
    });
  };

  useEffect(() => {
    selectedClaimId.current = viewClaimDialog?.params?.claimId;
    getPreviewData();
    // calculateTotals();
  }, [viewClaimDialog, getPreviewData, dataVersion]);

  useEffect(() => {
    calculateTotals();
  }, [calculateTotals]);

  const [viewCustomerInvoiceDialog, setViewCustomerInvoiceDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
    custInfo: [],
  });

  // console.table(invoiceGridData);

  var claimCode = selectedClaimPreview.claimCode ? selectedClaimPreview.claimCode : 0;
  var country = selectedClaimPreview.country ? selectedClaimPreview.country : 0;
  var year = selectedClaimPreview.year ? selectedClaimPreview.year : 0;
  var startMonth = selectedClaimPreview.startMonth ? selectedClaimPreview.startMonth : 0;
  var endMonth = selectedClaimPreview.endMonth ? selectedClaimPreview.endMonth : 0;
  const showReceivedPaymentDetails = String(claimCode).endsWith("0");
  // var paymentTypeId = selectedClaimPreview.paymentTypeId
  //   ? selectedClaimPreview.paymentTypeId
  //   : 0;
  // var claimStateId = selectedClaimPreview.claimStateId
  //   ? selectedClaimPreview.claimStateId
  //   : 0;
  // var initPayableBankAccountId = selectedClaimPreview.PayableBankAccountId
  //   ? selectedClaimPreview.PayableBankAccountId
  //   : 0;

  // console.log("PayableBankAccountId", PayableBankAccountId);

  // const isFirstRender = useRef(true);

  function formatToLocalDate(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (date < new Date("1970-01-01T00:00:00Z")) {
      return "00-00-0000";
    }

    return date.toLocaleDateString("nl-NL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }

  useEffect(() => {
    // setSelectedPaymentTypeId(selectedClaimPreview.paymentTypeId);
    setSelectedClaimStateId(selectedClaimPreview.claimStateId);
    setSelectedBankAccount(selectedClaimPreview.payableBankAccountId);
    // setSelectedLiters(selectedClaimPreview.liters);
    // setSelectedAdvancedRefundAmountEUR(
    //   selectedClaimPreview.advancedRefundAmountEUR
    // );
    setSelectedClaimDate(formatToLocalDate(selectedClaimPreview.claimDate));
    // setSelectedNotificationDate(
    //   moment(selectedClaimPreview.notificationDate).format("YYYY-MM-DD")
    // );

    function isValidDate(date) {
      const nonRealDates = ["0000-00-00", "01-01-1900", "01-01-1970", "00-00-0000", "01-01-0001", "0001-01-01", "0001-01-01T00:00:00"];
      return !nonRealDates.includes(date);
    }

    const claimCode = selectedClaimPreview?.claimCode || "";
    const lastTwoDigits = claimCode.slice(-2);
    let calculatedDate = null;

    if (lastTwoDigits === "00") {
      // calculatedDate = "N/A"; // Moet Notification date worden
      calculatedDate = formatToLocalDate(selectedClaimPreview.notificationDate);
      // console.log(selectedClaimPreview);
    } else if (lastTwoDigits === "01") {
      // calculatedDate = "N/A"; // Moet Pay Date worden checken ook in lijst
      const payDate = formatToLocalDate(selectedClaimPreview.payDate);
      calculatedDate = isValidDate(payDate) ? payDate : "N/A";
    } else if (lastTwoDigits === "10") {
      calculatedDate = "N/A";
    } else if (lastTwoDigits === "11") {
      calculatedDate = "Pre-Financed";
    } else {
      const date = formatToLocalDate(selectedClaimPreview.payDate);
      calculatedDate = isValidDate(date) ? date : "N/A";
    }

    setSelectedReimbursementDate(calculatedDate);
  }, [selectedClaimPreview, customerId, claimCode]);

  // console.log("Test", selectedClaimPreview);

  // const handleInvoiceLabelUpdate = (params) => {
  //   const rowIndex = invoiceGridData.findIndex(
  //     (row) => row.customerInvoiceId === params.customerInvoiceId
  //   );
  //   invoiceGridData[rowIndex].invoiceLabelId = params.invoiceLabelId;
  // };

  // const handleInvoiceStateUpdate = (params) => {
  //   const rowIndex = invoiceGridData.findIndex(
  //     (row) => row.customerInvoiceId === params.customerInvoiceId
  //   );
  //   invoiceGridData[rowIndex].invoiceStateId = params.invoiceStateId;

  //   // Invoice to next claim
  //   // console.table(invoiceStateData);
  //   let invoiceStateId = invoiceStateData.find(
  //     (x) => x.invoiceStateShortCode === "TNC"
  //   ).invoiceStateId;
  //   if (params.invoiceStateId === invoiceStateId) {
  //   }
  //   // console.log(invoiceStateId);
  //   calculateTotals();
  // };

  const columns = [
    {
      field: "invoiceNumber",
      headerName: t("Invoice Number"),
      flex: 0.5,
      hide: false,
    },
    {
      field: "invoiceDate",
      headerName: t("Invoice Date"),
      flex: 0.4,
      valueFormatter: (params) => formatToLocalDate(params?.value),
    },
    {
      field: "supplierId",
      headerName: t("Supplier"),
      flex: 0.5,
      valueGetter: (params) => supplierData.find((supplier) => supplier.supplierId === params.row.supplierId)?.supplierName,
    },
    {
      field: "productTypeId",
      headerName: t("Product"),
      flex: 0.4,
      valueGetter: (params) =>
        productData.find((product) => product.productTypeId === params.row.claimProductTypeId)?.productShortDescription,
    },
    {
      field: "countryCode",
      headerName: t("Country"),
      flex: 0.3,
      valueGetter: (params) => countryData.find((country) => country.countryId === params.row.countryCode).countryCode,
    },
    {
      field: "currencyId",
      headerName: t("Currency"),
      flex: 0.3,
      valueGetter: (params) => currencyData.find((cur) => cur.currencyId === params.row.currencyId).isoCode,
    },
    {
      field: "invoiceVATAmountLocalCurrency",
      headerName: t("Local VAT Amount"),
      flex: 0.5,
      renderCell: (params) => (
        <div style={{ textAlign: "right", paddingRight: "5px" }}>
          {params.value.toLocaleString("nl-NL", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </div>
      ),
      align: "right",
    },
    {
      field: "fileId",
      headerName: t("Invoice PDF available"),
      flex: 0.5,
      renderCell: (params) =>
        params.value > 0 ? (
          <CheckCircleOutlineIcon style={{ color: "green", margin: "0 auto" }} />
        ) : (
          <CheckCircleOutlineIcon style={{ color: "red", margin: "0 auto" }} />
        ),
    },
    {
      field: "actions",
      headerName: t("Actions"),
      flex: 0.3,
      renderCell: (params) => {
        return (
          <Box>
            <IconButton
              onClick={(e) => {
                setViewCustomerInvoiceDialog({
                  isOpen: true,
                  downloadFile: true,
                  title: t("View Invoice"),
                  params: params.row,
                  claimStateId: selectedClaimPreview?.claimStateId,
                  custInfo: [{ customerId: customerId, customerNumber: customerNumber }],
                  subTitle: t("Are you sure you want to manage {{name}}?", { name: params.row.contactName }),
                  handleFile: () => {
                    handleFile(updatedData);
                  },
                });
              }}
            >
              <VisibilityIcon />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  const FooterRow = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 10,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ fontWeight: "bold", marginRight: 10 }}>{t("Total Gross Amount")}:</div>
          <div>
            {gridTotalGrossAmount.toLocaleString("nl-NL", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
          <div style={{ fontWeight: "bold", marginLeft: 20, marginRight: 10 }}>{t("Total VAT Amount")}:</div>
          <div>
            {gridTotalVATAmount.toLocaleString("nl-NL", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        </div>
        <div>
          <GridFooter
          // pageSize={pageSize}
          // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          // rowsPerPageOptions={[15, 50, 100]}
          />
        </div>
      </div>
    );
  };

  var updatedData;

  const handleFile = (updatedData) => {};

  const getRowClassName = (params) => {
    const invoiceGrossAmount = params.row.invoiceGrossAmount;
    const invoiceStateId = params.row.invoiceStateId;

    if (invoiceStateId === 4) {
      return "highlight-row-removed";
    }

    if (invoiceStateId === 3) {
      return "highlight-row-ready-for-claim";
    }

    if (invoiceStateId === 2) {
      return "highlight-row-not-claimable";
    }

    if (invoiceStateId === 9) {
      return "highlight-row-rejected";
    }

    if (invoiceGrossAmount > 3000) {
      return "highlight-row";
    }

    return "";
  };

  // const handleClosePopup = () => {
  //   setShowPopup(false);
  // };

  // const handleClickOpenConfirmation = () => {
  //   setOpenConfirmation(true);
  // };

  // const handleCloseConfirmation = () => {
  //   setOpenConfirmation(false);
  // };

  // console.log("Selected Bank Account:", selectedBankAccount);

  const ColorLegend = () => (
    <Box display="flex" justifyContent="flex-end" alignItems="center" mt={2} mb={2}>
      <Typography variant="body2" style={{ fontSize: "0.8rem", marginRight: "10px" }}>
        {t("Legend")}:
      </Typography>
      <Box display="flex" alignItems="center" mr={2}>
        <Box width={15} height={15} bgcolor="#c8e6c9" mr={0.5} />
        <Typography variant="body2" style={{ fontSize: "0.8rem" }}>
          {t("OK")}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" mr={2}>
        <Box width={15} height={15} bgcolor="#fae7e7" mr={0.5} />
        <Typography variant="body2" style={{ fontSize: "0.8rem" }}>
          {t("Rejected")}
        </Typography>
      </Box>
      {/* <Box display="flex" alignItems="center">
        <Box width={15} height={15} bgcolor="#a5d8ff" mr={0.5} />
        <Typography variant="body2" style={{ fontSize: "0.8rem" }}>
          No Status (Pastel Blue)
        </Typography>
      </Box> */}
    </Box>
  );

  return (
    <>
      <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
      <div>
      {/* {showPopup && (
        <div style={overlayStyle}>
          <div style={popupStyle}>
            {responseMessage ? (
              <>
                <p>{responseMessage}</p>
                <p>
                  <button
                    onClick={handleClosePopup}
                    style={{
                      border: "none",
                      background: "none",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    Close
                  </button>
                </p>
              </>
            ) : (
              <p>Please wait, upload in progress...</p>
            )}
          </div>
        </div>
      )} */}
      <Dialog
        open={viewClaimDialog.isOpen}
        //   onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="xl"
      >
        <DialogTitle id="alert-dialog-title">{viewClaimDialog.title}</DialogTitle>
        <Divider />
        <DialogContent>
          <Card mb={6}>
            <CardContent>
              <Notification notify={notify} setNotify={setNotify} />
              {/* {alertInfo.message && (
                <Alert severity={alertInfo.type} my={3}>
                  {alertInfo.message}
                </Alert>
              )} */}

              <div>
                <Grid container xs={12} sx={{ mb: 5 }}>
                  <Grid container xs={6} spacing={1} sx={{ pr: 2 }}>
                    <Grid item xs={5}>
                      <Typography>{t("Claim Code")}:</Typography>
                    </Grid>
                    <Grid item xs={5}>
                      {claimCode}
                    </Grid>
                    <Grid item xs={5}>
                      <Typography>{t("Year")}:</Typography>
                    </Grid>
                    <Grid item xs={5}>
                      {year}
                    </Grid>
                    <Grid item xs={5}>
                      <Typography>{t("Period")}:</Typography>
                    </Grid>
                    <Grid item xs={5}>
                      {startMonth.toString().padStart(2, "0")} / {endMonth.toString().padStart(2, "0")}
                    </Grid>
                    <Grid item xs={5}>
                      <Typography>{t("Country")}:</Typography>
                    </Grid>
                    <Grid item xs={5}>
                      {countryData.find((country1) => country1.countryId === country)?.countryCode}
                    </Grid>
                    <Grid item xs={5}>
                      <Typography>{t("Claim State")}:</Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <Tooltip
                        title={
                          <React.Fragment>
                            {t("Claim state information")}
                            <ul>
                              <li>{t("Pending: Claim submitted to Tax Authorities, awaiting for being processed")}</li>
                              <li>{t("Finished: Claim processed by foreign Tax Authorities, decision had been made")}</li>
                              <li>{t("(Partly) Rejected Claims: (part of) Claim has been rejected")}</li>
                            </ul>
                          </React.Fragment>
                        }
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {(() => {
                            const code = selectedClaimPreview?.claimCode;
                            const isPreFinanced = code && String(code).slice(-2) === "11";
                            if (isPreFinanced) {
                              return t("Pre-Financed");
                            }
                            let displayText = "";
                            switch (selectedClaimStateId) {
                              case 1:
                                displayText = t("Collecting");
                                break;
                              case 3:
                                displayText = t("In progress");
                                break;
                              case 4:
                                displayText = t("Pending");
                                break;
                              case 16:
                                if (selectedClaimPreview.hasRejectedInvoices) {
                                  displayText = t("(Partly) Rejected");
                                } else {
                                  displayText = t("Finished");
                                }

                                break;
                              default:
                                displayText = "";
                            }
                            return displayText;
                          })()}
                          <InfoIcon
                            sx={{
                              color: "#376FD0",
                              ml: 1,
                              fontSize: 16,
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      </Tooltip>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography>{t("Claim Date")}:</Typography>
                    </Grid>
                    <Grid item xs={5}>
                      {selectedReimbursementDate === "Pre-Financed" ? (
                        <Tooltip
                          title={t(
                            "Due to pre-financing, the claim date is related to the individual invoices. Please look at the individual invoices to see when the payment took place."
                          )}
                        >
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {t("N/A")}
                            <InfoIcon
                              sx={{
                                color: "#376FD0",
                                ml: 1,
                                fontSize: 16,
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        </Tooltip>
                      ) : (
                        selectedClaimDate
                      )}
                    </Grid>
                    {/* <Grid item xs={5}>
                      <Typography>Notification Date:</Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <Tooltip title="Notification date information">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {selectedNotificationDate}
                          <InfoIcon
                            sx={{
                              color: "#376FD0",
                              ml: 1,
                              fontSize: 16,
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      </Tooltip>
                    </Grid> */}
                    <Grid item xs={5}>
                      <Typography>{t("Refund/Payout Date")}:</Typography>
                    </Grid>
                    <Grid item xs={5}>
                      {selectedReimbursementDate === "N/A" ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {t("N/A")}
                          <InfoIcon
                            sx={{
                              color: "#376FD0",
                              ml: 1,
                              fontSize: 16,
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      ) : selectedReimbursementDate === "Pre-Financed" ? (
                        <Tooltip
                          title={t(
                            "Due to pre-financing, the payout date is related to the individual invoices. Please look at the individual invoices to see when the payment took place."
                          )}
                        >
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {t("Pre-Financed")}
                            <InfoIcon
                              sx={{
                                color: "#376FD0",
                                ml: 1,
                                fontSize: 16,
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        </Tooltip>
                      ) : (
                        <Tooltip
                          title={t(
                            "In case the refund gets requested directly on the bank account of the customer (you), the actual Payout Date may differ a few days/weeks."
                          )}
                        >
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {selectedReimbursementDate}
                            <InfoIcon
                              sx={{
                                color: "#376FD0",
                                ml: 1,
                                fontSize: 16,
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        </Tooltip>
                      )}
                    </Grid>

                    {/* <Grid item xs={5}>
                      <Typography>Pay Date:</Typography>
                    </Grid>
                    <Grid item xs={5}>
                      {selectedPaymentDate}
                    </Grid> */}
                    <Grid item xs={5}>
                      <Typography>{t("Payable Bank Account")}:</Typography>
                    </Grid>
                    <Grid item xs={5}>
                      {!payableToDelta
                        ? bankAccounts.find((ba) => ba.bankAccountId === selectedBankAccount)?.iban
                        : t("Payable to Delta")}
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid item xs={12} sx={{ p: 5, pt: 3 }} backgroundColor="#376fd0">
                      <Grid container>
                        <Grid item xs={5}>
                          <Typography sx={{ fontSize: 22, color: "white" }}>{t("Invoice Count")}:</Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography
                            sx={{
                              fontSize: 22,
                              color: "white",
                              textAlign: "right",
                            }}
                          >
                            {invoiceCount}
                          </Typography>
                        </Grid>
                        <Grid item xs={5} />
                      </Grid>
                      <Grid container>
                        <Grid item xs={5}>
                          <Typography sx={{ fontSize: 22, color: "white" }}>{t("Total Gross Amount")}:</Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography
                            sx={{
                              fontSize: 22,
                              color: "white",
                              textAlign: "right",
                            }}
                          >
                            {(totalGrossAmount &&
                              totalGrossAmount.toLocaleString("nl-NL", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })) ||
                              "0,00"}
                          </Typography>
                        </Grid>
                        <Grid item xs={5} />
                      </Grid>
                      <Grid container>
                        <Grid item xs={5}>
                          <Typography sx={{ fontSize: 22, color: "white" }}>{t("Total VAT Amount")}:</Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography
                            sx={{
                              fontSize: 22,
                              color: "white",
                              textAlign: "right",
                            }}
                          >
                            {(totalVATAmount &&
                              totalVATAmount.toLocaleString("nl-NL", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })) ||
                              "0,00"}
                          </Typography>
                        </Grid>
                        <Grid item xs={5} />
                      </Grid>
                      <Grid container>
                        <Grid item xs={5}>
                          <Typography sx={{ fontSize: 22, color: "white" }}>{t("Missing Invoice Copies")}:</Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography
                            sx={{
                              fontSize: 22,
                              color: "white",
                              textAlign: "right",
                            }}
                          >
                            {missingInvoiceCopies}
                          </Typography>
                        </Grid>
                        <Grid item xs={5} />
                      </Grid>
                    </Grid>
                  {showReceivedPaymentDetails && (
                    <Box
                      sx={{
                        mt: 2,
                        pt: 0,
                        width: "100%",
                      }}
                    >
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                        {t("Received payment details")}
                      </Typography>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={5} md={4}>
                          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nl}>
                            <DatePicker
                              label={t("Payment received date")}
                              value={paymentReceivedDateValue}
                              onChange={(newValue) => {
                                if (!newValue) {
                                  setPaymentReceivedDateInput("");
                                  return;
                                }
                                if (!isValid(newValue)) return;
                                setPaymentReceivedDateInput(format(newValue, "yyyy-MM-dd"));
                              }}
                              inputFormat="dd-MM-yyyy"
                              disabled={isPaymentBusy}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  fullWidth
                                  variant="outlined"
                                  inputProps={{
                                    ...params.inputProps,
                                    "aria-label": t("Payment received date"),
                                  }}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={5} md={4}>
                          <TextField
                            label={t("Payment amount")}
                            type="text"
                            size="small"
                            fullWidth
                            value={paymentAmountInput}
                            onChange={(e) => setPaymentAmountInput(e.target.value)}
                            disabled={isPaymentBusy}
                            inputMode="decimal"
                            inputProps={{ "aria-label": t("Payment amount") }}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={4}
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 1,
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <Tooltip title={t("Save payment information")}>
                            <span>
                              <IconButton
                                type="button"
                                color="primary"
                                size="small"
                                onClick={handleSavePaymentClick}
                                disabled={isPaymentBusy}
                                aria-label={t("Save payment information")}
                                sx={{
                                  border: 1,
                                  borderColor: "primary.main",
                                  borderRadius: 1,
                                }}
                              >
                                {savingPayment ? (
                                  <CircularProgress size={24} color="inherit" />
                                ) : (
                                  <SaveOutlinedIcon sx={{ fontSize: 24 }} />
                                )}
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title={t("Remove payment information")}>
                            <span>
                              <IconButton
                                type="button"
                                color="error"
                                size="small"
                                onClick={handleRemovePaymentClick}
                                disabled={isPaymentBusy}
                                aria-label={t("Remove payment information")}
                                sx={{
                                  border: 1,
                                  borderColor: "error.main",
                                  borderRadius: 1,
                                }}
                              >
                                {removingPayment ? (
                                  <CircularProgress size={24} color="inherit" />
                                ) : (
                                  <DeleteOutlineIcon sx={{ fontSize: 24 }} />
                                )}
                              </IconButton>
                            </span>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <ColorLegend />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: 20,
                      backgroundColor: "#376fd0",
                      color: "white",
                    }}
                  ></div>
                  <ViewCustomerInvoiceDialog
                    viewCustomerInvoiceDialog={viewCustomerInvoiceDialog}
                    setViewCustomerInvoiceDialog={setViewCustomerInvoiceDialog}
                    countryArr={countryData}
                    supplierArr={supplierData}
                    currencyArr={currencyData}
                    productTypeArr={productData}
                    refreshGrid={getPreviewData}
                  />
                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "500px",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  ) : (
                    <DataGrid
                      getRowId={(row) => row.customerInvoiceId}
                      localeText={dataGridLocaleText}
                      disableSelectionOnClick
                      disableColumnSelector
                      components={{ Footer: FooterRow, Toolbar: GridToolbar }}
                      density="compact"
                      componentsProps={{
                        toolbar: {
                          csvOptions: { disableToolbarButton: true },
                          printOptions: { disableToolbarButton: true },
                          showQuickFilter: true,
                          quickFilterProps: { debounceMs: 250 },
                        },
                      }}
                      pagination
                      paginationMode="client"
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                      rowsPerPageOptions={[15, 50, 100]}
                      rows={invoiceGridData}
                      columns={columns}
                      ref={gridRef}
                      getRowClassName={getRowClassName}
                      sx={{
                        height: 500,
                        width: "100%",
                        borderRadius: 1,
                        backgroundColor: "background.paper",
                        boxShadow: 2,
                        "& .MuiDataGrid-cell:hover": {
                          color: "primary.main",
                        },
                        marginTop: 0,
                        ".highlight-row": {
                          bgcolor: "#ffeeba",
                        },
                        ".highlight-row-removed": {
                          bgcolor: "#fae7e7",
                        },
                        ".highlight-row-ready-for-claim": {
                          bgcolor: "#c8e6c9",
                        },
                        ".highlight-row-rejected": {
                          bgcolor: "#fae7e7",
                        },
                        ".highlight-row-not-claimable": {
                          bgcolor: "#d7ccc8",
                        },
                      }}
                    />
                  )}
                </Grid>
              </div>
              <Grid item container justifyContent="space-between" alignItems="center">
                <Grid item>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setViewClaimDialog({
                        ...viewClaimDialog,
                        isOpen: false,
                      });
                      setInvoiceGridData([]);
                      setSelectedClaimPreview([]);
                    }}
                    sx={{ marginTop: 3 }}
                  >
                    {t("Close")}
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </DialogContent>
      </Dialog>
      </div>
    </>
  );
}
